import { required } from 'helpers/CommonValidations';

const validations = {
  accountType: (state, id = 'accountType') => {
    return required(id, state[id]);
  },
  newAccountType: (state) => {
    return validations.accountType(state, 'newAccountType');
  },
  routingNumber: (state, id = 'routingNumber') => {
    const value = state[id];
    if (!value) {
      return required(id, value);
    }
    if (value.length && value.length < 9) {
      return { [id]: 'Must be 9 digits.' };
    }
    const arr = value.split('').map((i) => {
      return parseInt(i, 10);
    });
    const checksum =
      (3 * (arr[0] + arr[3] + arr[6]) +
        7 * (arr[1] + arr[4] + arr[7]) +
        (arr[2] + arr[5] + arr[8])) %
      10;
    // RGT-2250 "028000121" is a virtual routing number
    return checksum === 0 && value !== '028000121'
      ? { [id]: '' }
      : { [id]: 'Invalid routing number.' };
  },
  newRoutingNumber: (state) => {
    return validations.routingNumber(state, 'newRoutingNumber');
  },
  bankName: (state, id = 'bankName') => {
    return required(id, state[id]);
  },
  newBankName: (state) => {
    return validations.bankName(state, 'newBankName');
  },
  accountNumber: (state, id = 'accountNumber') => {
    const value = state[id];
    if (!value) {
      return required(id, value);
    }
    if (value.length > 17 || value.length < 4) {
      return { [id]: 'Must be between 4 and 17 digits.' };
    }
    const confirmValidation = validations.confirmAccountNumber(state);
    return { [id]: '', ...confirmValidation };
  },
  newAccountNumber: (state) => {
    return validations.accountNumber(state, 'newAccountNumber');
  },
  confirmAccountNumber: (
    state,
    id = 'confirmAccountNumber',
    accountNumberId = 'accountNumber'
  ) => {
    const value = state[id];
    if (!value) {
      return required(id, value);
    }
    if (value.length > 17 || value.length < 4) {
      return { [id]: 'Must be between 4 and 17 digits.' };
    }
    if (value !== state[accountNumberId]) {
      return { [id]: 'Must match Account Number.' };
    }
    return { [id]: '' };
  },
  newConfirmAccountNumber: (state) => {
    return validations.confirmAccountNumber(
      state,
      'newConfirmAccountNumber',
      'newAccountNumber'
    );
  },
  bankAccountAge: (state, id = 'bankAccountAge') => {
    return required(id, state[id]);
  },
  newBankAccountAge: (state) => {
    return validations.bankAccountAge(state, 'newBankAccountAge');
  }
};

export default validations;
